<template>
    <div class="home">
       <div> 
          <!-- <van-image src="obj.info.picUrl" width="100%" fit="cover"></van-image>-->
           <img class="img" :src="obj.info.picUrl" mode="WidthFix" /> 
           <div class="t_"> 
              <div class="goods_name_left">{{ obj.info.name}}</div>
              <div class="goodsNumb">价格： {{ obj.info.retailPrice }} 元</div>
              <div class="goodsNumb">库存： {{ obj.info.stockNum }}{{ obj.info.unit }}</div>
           </div>
           <div class="t_"> 
              <div class="title">商品参数：</div>
              <div class="t__"> 
                  <div v-for="(items,index) in obj.attribute" :key="index">
                      <div style="display: flex;align-items: center;"> 
                          <div class="t1">{{ items.attribute}}: </div>
                          <div class="si">{{ items.value }}</div>
                      </div>
                  </div>
              </div>
           </div>
           <div> 
              <van-button type="info" round plain  @click="Scheme">下 单</van-button>
           </div>
           
       </div>
    </div>
</template>

<script>
import request from '../api/request'
export default {
    data(){
        return{
           obj:{          
           },
           id:''
        }
    },
    mounted(){
        let that=this
        let geturl = window.location.href
       
        that.id = geturl.split("id=")[1]

        console.log(that.id)
        if (that.id == '') {
        that.$dialog.alert({
          message: '获取失败！',
        });
      }else{
        this.loadDetail()
      }
        
    },
    methods:{
        loadDetail(){
            let that=this
			request.postOther(
                {
                    id: that.id,
                    addressId: 0
                },'/wx/goods/detail','GET','',res=>{
				if(res.errno==0){
					
                    that.obj=res.data
                    // console.log(res)
				}
			})
        },
        Scheme() {
            let that=this
            const parms = 'id=' + that.id
            const pages = 'pages/goods/goods'
            request.postgetScheme(parms, pages, res => {
                console.log(res)
                if (res.errno == 0) {
                    location.href = res.data
                }
            })
        },
    }
}
</script>

<style scoped>
.home{
    height: 100vh;
    overflow: auto;
}
.img{width: 100%;}
.goods_name_left{
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 1px;
    width: 90%;
    text-align: left;
}
.title{
    text-align: left;font-size: 18px;font-weight: 500;
}
.t1{
    font-size: 16px; 
    font-weight: 500;
}
.t_{
    padding: 10px;
}
.t__{
    padding-top: 5px;
}
.si{font-size: 16px;}
.goodsNumb{
    text-align: left;
    font-size: 16px;
}
</style>